var React = require('react');

function ThemeToggler (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32ZM16 4C16.3368 4 16.6703 4.01387 17 4.04107V27.9589C16.6703 27.9861 16.3368 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4Z","fill":"currentColor"}));
}

ThemeToggler.defaultProps = {"width":"24","height":"24","viewBox":"0 0 32 32","fill":"none"};

module.exports = ThemeToggler;

ThemeToggler.default = ThemeToggler;
